import { DeviceFamily, Placement, PageType } from '@amzn/fire-tv-campaign-automation-service';

export type PageTypeConfig = Record<DeviceFamily, Partial<Record<Placement, PageType[]>>>;

export const PAGE_TYPE_CONFIG: PageTypeConfig = {
  [DeviceFamily.FIRE_TV]: {
    [Placement.FEATURE_ROTATOR]: [PageType.FTV_BROWSE, PageType.FTV_ROTATOR],
    [Placement.SCREEN_SAVER]: [PageType.FTV_BROWSE],
  },
  [DeviceFamily.FIRE_TABLETS]: {
    [Placement.FEATURE_ROTATOR]: [PageType.MOBILE_APPLICATION_STORE],
  },
};
